import { render, staticRenderFns } from "./BaseEmbeddedTip.vue?vue&type=template&id=e15c5c34&scoped=true"
import script from "./BaseEmbeddedTip.vue?vue&type=script&lang=js"
export * from "./BaseEmbeddedTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15c5c34",
  null
  
)

export default component.exports